import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_120: FaireProductEntity = {
  token: "starter_collection_120",
  type: "product",
  name: "Le Spritz - Sumac & Chili",
  brandName: "Ghia",
  imageUrl:
    '"https://cdn.faire.com/fastly/18190955f44da3df76e4457889c31c1dbd3f134c0e9786bd5f77de0152bfa074.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=863',
  priceDollars: 48,
  msrpDollars: 96,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
